
import props from './props'
export default {
  props,
  data() {
    return {
      selected: '',
    }
  },
  watch: {
    attributes: {
      handler(newValue) {
        if (typeof newValue?.value !== 'undefined') {
          this.selected = newValue?.value
        } else {
          this.selected = this.defaultValue
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
